<template>
  <div class="pure-u-4-5 login-container l-box">
    <h1>{{appTitle}}</h1>
    <div>
      <p>Make daily notes.</p>
      <p><a class="pure-button login-button" href="/login">Login to start</a></p>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters([
      "appTitle",
      "loading",
    ]),
  },
};
</script>
<style>
.login-container {
  margin-right: auto;
  margin-left: auto;
}
.login-button {
  background: #03a9f4;
  color: #FEFEFE;
}
</style>



// WEBPACK FOOTER //
// LoginPage.vue?ded9876e